import { render, staticRenderFns } from "./human-analysis.vue?vue&type=template&id=1d6b77d8&scoped=true&"
import script from "./human-analysis.vue?vue&type=script&lang=js&"
export * from "./human-analysis.vue?vue&type=script&lang=js&"
import style0 from "./human-analysis.vue?vue&type=style&index=0&id=1d6b77d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b77d8",
  null
  
)

export default component.exports